import { render, staticRenderFns } from "./DraggableElements.vue?vue&type=template&id=63e5d487&scoped=true&"
import script from "./DraggableElements.vue?vue&type=script&lang=js&"
export * from "./DraggableElements.vue?vue&type=script&lang=js&"
import style0 from "./DraggableElements.vue?vue&type=style&index=0&id=63e5d487&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e5d487",
  null
  
)

export default component.exports